import { Loader } from "@googlemaps/js-api-loader";

function initLatLongMap() {
	console.log("init");
	const $llforms = jQuery(".lll-form form");
	console.log($llforms);
	$llforms.each(function () {
		const $this = jQuery(this);

		const map = new google.maps.Map(document.getElementById("lll-map"), {
			zoom: 13,
			mapTypeId: "roadmap",
		});

		const address = document.getElementById("lll-address");
		const lat = document.getElementById("lll-lat");
		const lng = document.getElementById("lll-lng");
		let markers = [];

		const originAutocomplete = new google.maps.places.Autocomplete(address);

		originAutocomplete.addListener("place_changed", function (event) {
			const place = originAutocomplete.getPlace();

			if (!place.geometry) {
				return;
			}

			lat.value = place.geometry.location.lat();
			lng.value = place.geometry.location.lng();

			const icon = {
				url: place.icon,
				size: new google.maps.Size(71, 71),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(17, 34),
				scaledSize: new google.maps.Size(25, 25),
			};

			// Clear out the old markers.
			markers.forEach((marker) => {
				marker.setMap(null);
			});
			markers = [];

			const bounds = new google.maps.LatLngBounds();

			markers.push(
				new google.maps.Marker({
					map,
					icon,
					title: place.name,
					position: place.geometry.location,
				})
			);

			if (place.geometry.viewport) {
				// Only geocodes have viewport.
				bounds.union(place.geometry.viewport);
			} else {
				bounds.extend(place.geometry.location);
			}

			map.fitBounds(bounds);
		});

		$this.on("submit", function (e) {
			e.preventDefault();
		});
	});
}

const loader = new Loader({
	apiKey: lll_front.api_key,
	version: "weekly",
	libraries: ["places"],
});

loader.load().then(async () => {
	initLatLongMap();
});
